import {
  faLayerGroup,
  faMarker,
  faUserGroupSimple,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  GroupByOption,
  GenerateAsOption,
  ParticipantGroupOption,
} from 'api/custom-section/types';
import { startCase } from 'lodash';
import { useAccountInitialDataQuery } from 'queries/account';
import { FormattedMessage } from 'react-intl';
import {
  PreviewConfiguration,
  PreviewConfigurationItem,
} from 'components/organisms/document-editor/extensions/custom-section/ui/shared/section-styles';

interface PreviewConfigurationProps {
  prompt: {
    groupBy?: GroupByOption;
    generateAs?: GenerateAsOption;
    participants?: ParticipantGroupOption;
  };
}

export const SharedPreviewConfiguration = ({
  prompt,
}: PreviewConfigurationProps) => {
  const { data: accountData } = useAccountInitialDataQuery();
  const accountMeta = accountData?.accountMeta;

  return (
    <PreviewConfiguration>
      {prompt.groupBy && (
        <PreviewConfigurationItem>
          <FontAwesomeIcon icon={faLayerGroup} />
          {/* TODO: change to proper translation */}
          <FormattedMessage
            id="rich_text_editor.sections.type"
            values={{
              type: startCase(prompt.groupBy.toLowerCase()),
            }}
          />
        </PreviewConfigurationItem>
      )}
      {prompt.generateAs && (
        <PreviewConfigurationItem>
          <FontAwesomeIcon icon={faMarker} />
          <FormattedMessage
            id="rich_text_editor.sections.type"
            values={{
              type: startCase(prompt.generateAs.toLowerCase()),
            }}
          />
        </PreviewConfigurationItem>
      )}
      {prompt.participants && (
        <PreviewConfigurationItem>
          <FontAwesomeIcon icon={faUserGroupSimple} />
          <FormattedMessage
            id={`rich_text_editor.sections.participant_group.${prompt.participants}`.toLowerCase()}
            values={{
              accountName: accountMeta?.company?.companyName,
            }}
          />
        </PreviewConfigurationItem>
      )}
    </PreviewConfiguration>
  );
};
